/**
 * 고객이 글 없이 첨부만 보낼 때 web 이 content 에 넣는 자리 문구
 * (locarora-web messages.fileSent, 8개 언어). 목록 미리보기·푸시용이라 저장은 그대로 둔다.
 */
const ATTACHMENT_PLACEHOLDERS = new Set([
  "파일을 보냈습니다",
  "File sent",
  "ファイルを送信しました",
  "檔案已發送",
  "文件已发送",
  "ส่งไฟล์แล้ว",
  "Đã gửi tệp",
  "File terkirim",
]);

/**
 * 사진만 있고 글은 자리 문구뿐인 메시지 — 말풍선 없이 사진 묶음만 보여 준다.
 * 판단은 보낸 원문(content)으로 한다. 번역 칸은 기계 번역이라 문구가 달라질 수 있다.
 */
export function isPhotoOnlyPlaceholder(message: {
  content?: string | null;
  attachments?: { type: string }[] | null;
}): boolean {
  const attachments = message.attachments ?? [];
  if (attachments.length === 0) return false;
  if (attachments.some((a) => a.type !== "image")) return false;
  return ATTACHMENT_PLACEHOLDERS.has((message.content ?? "").trim());
}
